
import { defineComponent, toRef, ref, computed } from "vue";
import carProps from "./props";
import { CModalInstance, Toast } from "@/ui";
import { FormItem, FormValue } from "@/components/form-area/type";
import formArea, { FormAreaInstance } from "@/components/form-area";
import { randomString } from "@/common/tool";
import api, { User } from "@/api";
import { getUser } from "@/common/storage";

const checkNum = (number: string) => {
  // 普通车牌
  const normal = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{5,6}$/u;
  // 特种车牌(学、挂、领、试、超、练、警)
  const special =
    /^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新]{1}[ABCDEFGHJKLMNPQRSTUVWXY]{1}[0-9A-Z]{4}[学挂领试超练警]{1}$/u;
  // 武警车牌
  const police = /^WJ[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新]?[0-9A-Z]{5}$/iu;
  // 军牌
  const army = /^[QVKHBSLJNGCEZ]{1}[ABCDEFGHJKLMNPQRSTUVWXY]{1}[0-9A-Z]{5}$/u;
  return normal.test(number) || special.test(number) || police.test(number) || army.test(number);
};
let labelStyle = "padding: 0;";
const carForm: FormItem[] = [
  {
    component: "input",
    key: "num",
    label: "车牌号码",
    must: true,
    placeholder: "请输入车牌号码",
    rules: [
      {
        rule: { required: true, message: "请输入车牌号码" },
        title: "必填",
        type: 1,
      },
      {
        rule: { custom: checkNum, message: "请输入正确车牌号码" },
        title: "必填",
        type: 1,
      },
    ],
    type: "text",
    labelStyle,
  },
  {
    component: "input",
    key: "name",
    label: "联系人",
    must: true,
    placeholder: "请输入联系人姓名",
    rules: [
      {
        rule: { required: true, message: "请输入联系人姓名" },
        title: "必填",
        type: 1,
      },
    ],
    type: "text",
    labelStyle,
  },
  {
    component: "input",
    key: "tel",
    label: "联系方式",
    must: true,
    placeholder: "请输入联系方式",
    rules: [
      {
        rule: { required: true, message: "请输入联系方式" },
        title: "必填",
        type: "tel",
      },
    ],
    type: "tel",
    labelStyle,
  },
];
const recForm: FormItem[] = [
  {
    component: "input",
    type: "textarea",
    label: "识别内容",
    key: "str",
    placeholder: "请输入待识别的内容",
    noGap: true,
    rules: [
      {
        rule: { required: true, message: "请输入待识别的内容" },
        title: "必填",
        type: 1,
      },
    ],
  },
];

export default defineComponent({
  name: "CarAdd",
  components: { formArea },
  props: { ...carProps },
  setup(props, { emit }) {
    const num = ref("");
    const modal = ref<CModalInstance | null>(null);
    const formRef = ref<FormAreaInstance | null>(null);
    const formType = ref<string>("input");
    const eIndex = ref<number>(-1);
    const initial = ref<FormValue>();
    const list = computed<FormValue[]>({
      get() {
        let res: FormValue[] = [];
        const value = toRef(props, "modelValue").value;
        if (value) {
          res = [...value];
        }
        return res;
      },
      set(val) {
        // console.log("set:", val);
        emit("update:modelValue", val);
      },
    });

    const getClipboardData = async (): Promise<string> => {
      let text = "";
      if (navigator.clipboard) {
        try {
          text = await navigator.clipboard.readText();
        } catch (err) {
          console.log("读取失败:", err);
        }
      } else {
        console.log("浏览器不支持");
      }
      return text;
    };
    const showCarModal = (type: string, car: FormValue) => {
      if (type == "auto") {
        getClipboardData()
          .then((data) => {
            if (data) {
              car.str = data;
            }
          })
          .finally(() => {
            formType.value = type;
            initial.value = car;
            modal.value?.show();
          });
      } else {
        formType.value = type;
        initial.value = car;
        modal.value?.show();
      }
    };
    const recNum = () => {
      initial.value = {};
      showCarModal("auto", initial.value);
    };
    const showAdd = () => {
      initial.value = {};
      showCarModal("input", initial.value);
    };
    const removeCar = (i: number) => {
      const arr = [...list.value];
      arr.splice(i, 1);
      list.value = arr;
    };
    const addCar = () => {
      return new Promise<void>((resolve, reject) => {
        formRef.value
          ?.submit()
          .then((form: FormValue) => {
            if (eIndex.value >= 0) {
              list.value[eIndex.value] = { ...form };
              list.value = [...list.value];
              eIndex.value = -1;
            } else {
              let key = randomString(16);
              let temp = { key, ...form };
              list.value = [...list.value, temp];
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    };
    const autoRec = () => {
      return new Promise<void>((resolve, reject) => {
        formRef.value?.submit().then((form) => {
          api
            .recCarNumber({ str: form.str as string })
            .then((res) => {
              if (res.length > 0) {
                const user = getUser() as User;
                // const name = user.real_name || user.uname || "";
                const mobile = user.mobile || "";
                let carList: FormValue[] = [];
                res.forEach((num, index) => {
                  if (!checkNum(num)) {
                    return;
                  }
                  if (list.value.findIndex((item) => item.num == num) === -1) {
                    carList.push({
                      num,
                      name: "访客" + (index + 1),
                      tel: mobile,
                    });
                  }
                });
                list.value = [...list.value, ...carList];
                resolve();
              } else {
                Toast("未识别到任何车牌，请重新复制后再识别");
                reject();
              }
            })
            .catch(() => {
              reject();
            });
        });
      });
    };
    const editCar = (i: number) => {
      formType.value = "input";
      initial.value = { ...list.value[i] };
      eIndex.value = i;
      modal.value?.show();
    };

    const confirmAdd = () => {
      if (formType.value == "auto") {
        return autoRec();
      } else {
        return addCar();
      }
    };

    return {
      num,
      list,
      modal,
      removeCar,
      recNum,
      showAdd,
      confirmAdd,
      editCar,
      formRef,
      initial,
      formType,
      formConfig: {
        auto: recForm,
        input: carForm,
      } as FormValue,
    };
  },
});
